import { useEffect, useRef } from 'react';
import useAuthStore from '../stores/useAuthStore';

const TAWK_PROPERTY_ID = `${process.env.REACT_APP_TAWK_PROPERTY_ID}`;
const TAWK_WIDGET_ID = `${process.env.REACT_APP_TAWK_WIDGET_ID}`;
const TAWK_SUPPORT_ID = `${process.env.REACT_APP_TAWK_SUPPORT_ID}`;


const WIDGET_IDS = {
  default: TAWK_WIDGET_ID,
  supportTab: TAWK_SUPPORT_ID, 
};

export const useTawkTo = (widget = 'default', enabled = true) => {
  const hasLoaded = useRef(false);
  const { user, isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (!enabled || hasLoaded.current || typeof window === 'undefined') return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    window.Tawk_API.widgetId = WIDGET_IDS[widget];

    window.Tawk_API.onLoad = () => {
      hasLoaded.current = true;

      if (isAuthenticated && user?.email) {
        window.Tawk_API.setAttributes({
          name: user.name || user.email.split('@')[0],
          email: user.email,
        }, (error) => {
          if (error) console.warn('Tawk prefill error:', error);
        });
      }
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${WIDGET_IDS[widget]}`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.head.appendChild(script);

    return () => {
      if (window.Tawk_API?.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
  }, [widget, enabled, isAuthenticated, user]);
};
